import React from 'react';
import BBDataTable from "../tables/BBDataTable";
import {bbFormattedDateString, mapObject} from "../../../util/bbHelpers";
import {renderCellExpand} from "../tables/DataGridRenderCellExpand";

const TargetDetailsCrawlTable = ({scans = [], })=>{

    let resultsArray;

   scans.forEach((scan)=>{
       const results = scan && scan.results && JSON.parse(scan.results).results;
       // const crawled = results && results.crawled;
       // const crawledURLs = results && results.crawled && Object.keys(results.crawled);
       // const logins = results && results.logins && Object.values(results.logins);

       const crawled = results && results.crawled ? results.crawled : {};
       const crawledURLs = results && results.crawled && Object.keys(results.crawled).length >0 ? Object.keys(results.crawled) : ["--"];
       const logins = results && results.logins ? Object.values(results.logins) : ["--"];


       resultsArray = crawledURLs.map((crawledURL, index)=>{
           return({
               ...scan,
               id: `${scan.id}_${index}`,
               crawledURL: crawledURL !== "--" ? crawledURL : scan.url,
               pageTitle: crawled[crawledURL] ? crawled[crawledURL] : "--",
               numLogins: logins && logins.length ? logins.length : "0",
           })
       })
   })

    // console.log("resultsArray",resultsArray);

   const columns=[
       { field: "created_datetime", headerName: "Crawl Date", hide: false, flex: 1, sortable: false, renderCell: (params)=>
       renderCellExpand(params, (
           <span>
               {bbFormattedDateString(params.value, "shortFullMonth")}
           </span>
       ))},
       { field: "url", headerName: "URL", hide: false, sortable: false, flex: 1, renderCell: (params)=>
               renderCellExpand(params, (
                   <span>
               {params.value}
           </span>
               ))},
       { field: "pageTitle", headerName: "Page Title", hide: false, flex: 1, sortable: false, renderCell: (params)=>
               renderCellExpand(params, (
                   <span>
               {params.value ? params.value : "--"}
           </span>
               ))},
       { field: "subdomain", headerName: "Subdomain", hide: false, flex: 1, sortable: false, renderCell: (params)=>
               renderCellExpand(params, (
                   <span>
               {params.value ? params.value : "--"}
           </span>
               ))},
   ]

    // const tableData = scans && Array.isArray(scans) ? scans.map((object) => {
    //
    //     return(
    //         {
    //
    //         }
    //     )
    // }

    return(
        <div>
            {resultsArray ?
                <BBDataTable
                    columns={columns}
                    rows={resultsArray}
                    totalRows={resultsArray.length}
                    title={null}
                    loading={false}
                    disableColumnSelector
                    disableDensitySelector
                    disableColumnMenu
                    disableColumnFilter
                />
                :
                <BBDataTable
                    columns={columns}
                    rows={[]}
                    title={null}
                    loading={true}
                    progressValue={0}
                    disableColumnSelector
                    disableDensitySelector
                    disableColumnMenu
                    disableColumnFilter
                />
            }
        </div>
    )
}

export default TargetDetailsCrawlTable;
